// TODO: VL-6033 - re-write the vl_chat FE by FE engineers.

import { useCopilotAction } from "@copilotkit/react-core";

/**
 * VLChatNavigateAction Component
 * 
 * This component registers a CopilotKit action that allows the backend
 * LangGraph agent to trigger frontend navigation to exploration results.
 * 
 * The action is only available to the backend ("remote") and handles
 * navigation by constructing the URL with query parameters and using
 * window.location for navigation.
 */
export function VLChatNavigateAction() {

  // The useCopilotAction hook signature seems to have changed in v1.10.2
  // Using single argument form based on TypeScript error
  (useCopilotAction as any)({
    name: "navigateToExploration",
    followUp: false,
    description: "Navigate to dataset exploration results with filters applied",
    available: "remote", // Only available to the backend agent
    parameters: [
      {
        name: "path",
        type: "string",
        description: "The base URL path (e.g., /dataset/abc-123/data)",
        required: true,
      },
      {
        name: "entity_type",
        type: "string",
        description: "Entity type filter (IMAGES or OBJECTS)",
        required: false,
      },
      {
        name: "granularity",
        type: "string",
        description: "Cluster granularity threshold (e.g., 0.9, 0.95)",
        required: false,
      },
      {
        name: "vql",
        type: "string",
        description: "VQL filters as JSON string",
        required: false,
      },
      {
        name: "q",
        type: "string",
        description: "Search query text for semantic or FTS search",
        required: false,
      },
      {
        name: "search_text_threshold",
        type: "string",
        description: "Threshold for semantic search (e.g., 0.8, 0.85)",
        required: false,
      }
    ],
    handler: async ({ path, entity_type, granularity, vql, q, search_text_threshold }: any) => {
      try {
        // Build query parameters
        const params = new URLSearchParams();
        
        // Add entity type if provided
        if (entity_type) {
          params.set("t", entity_type);
        }
        
        // Add granularity if provided
        if (granularity) {
          params.set("granularity", granularity);
        }
        
        // Add VQL if provided (URLSearchParams will handle encoding)
        if (vql) {
          params.set("vql", vql);
        }
        
        // Add search query if provided
        if (q) {
          params.set("q", q);
        }
        
        // Add search threshold if provided
        if (search_text_threshold) {
          params.set("search_text_threshold", search_text_threshold);
        }
        
        // Construct the full URL
        const queryString = params.toString();
        const fullUrl = queryString ? `${path}?${queryString}` : path;
        
        // Log navigation for debugging
        console.log("[VLChatNavigateAction] Navigating to:", fullUrl);
        console.log("[VLChatNavigateAction] Parameters:", {
          path,
          entity_type,
          granularity,
          vql_length: vql?.length || 0,
          q,
          search_text_threshold
        });
        
        // Validate that the path is an internal route
        if (!path.startsWith("/dataset/")) {
          console.error("[VLChatNavigateAction] Invalid path - must start with /dataset/");
          throw new Error("Invalid navigation path");
        }
        
        // Navigate to the URL using window.location
        // This avoids the Router context requirement
        window.location.href = fullUrl;
        
        // Return success message
        return "Successfully navigated to exploration results";
      } catch (error) {
        console.error("[VLChatNavigateAction] Navigation failed:", error);
        throw error;
      }
    },
  });

  // This component doesn't render anything
  return null;
}

export default VLChatNavigateAction;